import { useEffect } from "react";

import { initializeRum } from "../services/rum/client";
import { useRumConfigQuery } from "../services/rum/rum";

export function RumBootstrap() {
  // RUM currently cheats and does not use frontend feature flag,
  // which needs to be addressed during proper feature flags implementation
  const rumConfigQuery = useRumConfigQuery();

  useEffect(() => {
    if (!rumConfigQuery.data?.enabled) {
      return;
    }

    initializeRum(rumConfigQuery.data);
  }, [rumConfigQuery.data]);

  return null;
}
